<template lang="pug">
  .contact
    snackbar(v-model="showSnackbar" :snackbar="snackbarProps")
    .contact__banner
      h1.contact__banner_center-text.white--text Contato
    .max-content
      v-row.contact__card.wrap.ma-3.mb-10(justify="center")
        v-col.text-center(cols="12")
          h1.primary--text.mt-10.mb-4 Entre em Contato!
        v-col.text-center(cols="12" md="7" lg="6")
          form()
            v-text-field(
              outlined
              v-model="contact.name"
              label="Nome*"
            )
            v-text-field(
              outlined
              v-model="contact.email"
              :rules="[v => /.+@.+/.test(v) || 'E-mail inválido']"
              label="E-mail Corporativo*"
            )
            v-text-field(
              outlined
              v-model="contact.phone"
              :rules="[numberRule]"
              counter="11"
              type="number"
              label="Telefone*"
            )
            v-text-field(
              outlined
              v-model="contact.company"
              label="Empresa*"
            )
            v-select(
              outlined
              v-model="contact.select"
              :items="items"
              label="Sobre o que gostaria de falar?*"
            )
            v-textarea(
              outlined
              v-model="contact.message"
              label="Mensagem*"
            )
            v-row.flex-column.align-end.justify-end.pa-3.pt-0
              small.mb-3 * Todos os campos são obrigatórios
              v-btn.text-right.primary(
                @click="sendEmail"
                :loading="loading"
                :disabled="loading || !hasAllFields"
              ) submit
    .contact__banner-2
      g-map(street="Rua Presidente Nereu Ramos, 102")
</template>

<script>
import emailjs from 'emailjs-com';
import Snackbar from '@/components/Snackbar.vue';
import GMap from '@/components/GoogleMap.vue';

export default {
  name: 'contact-page',
  components: { Snackbar, GMap },
  data: () => ({
    numberRule: num => {
      if (!isNaN(parseFloat(num)) && num.toString().length >= 10 && num.toString().length < 12) return true;
      return 'Número inválido';
    },
    showSnackbar: false,
    loading: false,
    snackbarProps: {},
    contact: {},
    items: [
      'Comercial',
      'Financeiro',
      'Suporte',
    ]
  }),
  computed: {
    hasAllFields() {
      return this.contact
          && this.contact.name
          && this.contact.email
          && this.contact.phone
          && this.contact.company
          && this.contact.select
          && this.contact.message;
    }
  },
  methods: {
    sendEmail() {
      if (!this.hasAllFields) return;
      this.showSnackbar = false;
      this.loading = true;
      const message_html = `<p><strong>Nome: </strong>${this.contact.name}</p>
                            <p><strong>E-mail: </strong>${this.contact.email}</p>
                            <p><strong>Telefone: </strong>${this.contact.phone}</p>
                            <p><strong>Empresa: </strong>${this.contact.company}</p>
                            <p><strong>Objetivo: </strong>${this.contact.select}</p>
                            <p><strong>Mensagem: </strong>${this.contact.message}</p>`;
      emailjs.send(
        'default_service',
        'template_isptotem',
        { message_html },
        'user_XEpplzet1JmqT1Lqsc02B'
      ).then(() => {
        this.snackbarProps = { type: 'success', message: 'Email enviado com sucesso. Entraremos em contato!' };
      }).catch(() => {
        this.snackbarProps = { type: 'error', message: 'Não foi possível enviar o email. Tente novamente!' };
      }).finally(() => {
        this.loading = false;
        this.showSnackbar = true;
      });
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/style/mobileFirst.sass"
@import "@/assets/style/variables.sass"

.contact
  &__banner
    min-height: 200px
    background-position: center
    background-image: url('../assets/img/bg-contact-1.jpg')
    background-size: cover
    position: relative
    +media-min-md
      min-height: 40vh
    +media-min-lg
    &_center-text
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
  &__card
    background: rgba($white, .9)
    +media-min-md
      background: transparent
    h1
      font-size: 24px
      +media-min-md
        font-size: 30px
</style>